import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { clearNotification } from "./notificationsSlice";
import { useIntl } from "react-intl";
import { useIonToast } from "@ionic/react";

const Notifier = () => {
  const dispatch = useDispatch();
  const notifications = useSelector((state) => state.notifications);
  const intl = useIntl();
  const [present] = useIonToast();

  useEffect(() => {
    if (notifications.notifications.length > 0) {
      const { id, type, message: body, title } = notifications.notifications[0];
      const localizedMessage = intl.formatMessage({
        id: `app.mobile.notifications.${body}`,
      });
      const localizedTitle = intl.formatMessage({
        id: `app.mobile.notifications.${title}`,
      });
      if (type === "success") {
        present({
          color: "success",
          duration: 2000,
          position: "top",
          message: localizedMessage,
        });
      } else {
        present({
          color: "danger",
          duration: 2000,
          position: "top",
          message: `${localizedTitle}: ${localizedMessage}`,
        });
      }
      dispatch(clearNotification(id));
    }
  }, [dispatch, intl, notifications.notifications]);

  return null;
};

export default Notifier;
